// removed by extract-text-webpack-plugin
module.exports = {"root":"_1vR1KvK","ball":"_1GGPMu3"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/Loader/Loader.less
 ** module id = 862
 ** module chunks = 0
 **/